module.exports = __webpack_public_path__ + "img/P7-zh.7c484815.png";